var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('pre-base',{ref:"mybase",attrs:{"pre_data":_vm.init_data},on:{"base2-event":_vm.refresh_father}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('div',{attrs:{"id":"notice"}},[_c('h5',[_vm._v("冲撞仪信息登记使用说明:"),_c('br'),_c('span',[_vm._v("1、直接录入即可")]),_c('br'),_c('span',[_vm._v("2、状态:只有提交状态可以使用,其他状态不可以")]),_c('br'),_c('span',[_vm._v("3、查询关键字:型号")]),_c('br')])])])
}]

export { render, staticRenderFns }